export default __webpack_public_path__ + "static/media/data.3d3a04aa.png";